import { FUNNEL } from "src/components/Charts/types";
import processFunnelEchartOption from "./funnel";
import applySerieContract from "./serieContract";

/**
 * Esta classe é responsável por adicionar uma camada de processamento
 * a cada echartOption associado à um tipo de gráfico especico antes das opções
 * serem enviadas como payload final para geração do relatório.
 */
export class ReportEchartOptionPreProcessor {
  /**
   * Estrategias de processamento, no momento só realizamos processamento adicional
   * no gráfico de funil
   */
  static strategies = {
    [FUNNEL]: (echartOption) => processFunnelEchartOption(echartOption),
  };

  static process(chartType, echartOption) {
    const fn = this.strategies[chartType];

    const processedEchartOption = typeof fn === "function"
      ? fn(echartOption)
      : echartOption;

    /**
     * O contrato de série vale para todo tipo de gráfico
     */
    return applySerieContract(processedEchartOption);
  }
}
